export const ActionTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  // POOL_DETAIL:"POOL_DETAIL",
  // REMAIN_TIME:"REMAIN_TIME",
  // USER_RANK:"USER_RANK",
  // WITHDRAW_INFO:"WITHDRAW_INFO",
  // LATEST_DEPOSIT:"LATEST_DEPOSIT"
};
